import { ALL_CUSTOMERS_GROUP_ID } from '../../../../../functions/customer'
import { PartialCustomerGroup } from '../types'

/**
 * Utility function to sort customer groups with "All customers" group first and the rest aplhabetically
 * @param customersGroup - array of customer groups
 * @returns - sorted array of customer groups with the default "All Customers" group first
 */
export const prioritizeDefaultGroup = (
  customersGroup: PartialCustomerGroup[]
) => {
  return [...customersGroup].sort((a, b) => {
    if (a.groupId === ALL_CUSTOMERS_GROUP_ID) {
      return -1
    } else if (b.groupId === ALL_CUSTOMERS_GROUP_ID) {
      return 1
    }
    // Otherwise, compare their names alphabetically
    return a.name.localeCompare(b.name)
  })
}
